import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { ProfileGroup } from 'src/modules/member/models/profileGroup';
import { MemberProfileGroupSearchFilter } from 'src/modules/memberProfile/models/memberProfileGroupSearchFilter';
import { ProfileGroupRequest } from 'src/modules/memberProfile/models/profileGroupRequest';

const profileGroupController = 'ProfileGroup';

// pageSize 0 betyder hela listan. Funktionen används av väljare, profilfilter och
// formulärinställningar som behöver alla profilgrupper att välja bland, inte en sida.
// Utan den skulle de kapas till API:ets standardsidstorlek.
export const getAllProfileGroups = (allProfileItems?: boolean, allProfileGroups?: boolean) => {
  const params: { [k: string]: boolean | number } = { pageSize: 0 };
  if (allProfileItems) params.allProfileItems = true;
  if (allProfileGroups) params.allProfileGroups = true;
  return AxiosInstance.get<PagedResult<ProfileGroup>>(`${profileGroupController}`, { params });
};

export const getAllProfileGroupsWithFilter = (searchFilter: MemberProfileGroupSearchFilter) => {
  const params: MemberProfileGroupSearchFilter = {
    allProfileItems: false,
    allProfileGroups: true,
    filter: searchFilter.filter,
    pageIndex: searchFilter.pageIndex,
    pageSize: searchFilter.pageSize,
    sortCol: searchFilter.sortCol,
    sortDir: searchFilter.sortDir,
    skipAccessFilter: searchFilter.skipAccessFilter,
  };

  if (searchFilter.districtId !== undefined) {
    params.districtId = searchFilter.districtId;
  }

  if (searchFilter.associationId !== undefined) {
    params.associationId = searchFilter.associationId;
  }

  return AxiosInstance.get<PagedResult<ProfileGroup>>(`${profileGroupController}`, { params });
};

export const getProfileGroupById = (id) => {
  return AxiosInstance.get<ProfileGroup>(`${profileGroupController}/${id}`);
};
export const getProfileGroupByIdAllItems = (id, allItems) => {
  return AxiosInstance.get<ProfileGroup>(`${profileGroupController}/${id}/${allItems}`);
};

export const createProfileGroup = (data: ProfileGroupRequest) => {
  return AxiosInstance.post<number>(profileGroupController, data);
};

export const updateProfileGroup = (data: ProfileGroupRequest) => {
  return AxiosInstance.put<ProfileGroupRequest>(profileGroupController, data);
};

export const deleteProfileGroup = (id: number) => {
  const endpoint = `${profileGroupController}/${id}`;
  return AxiosInstance.delete(endpoint);
};
